export const stringReduceAddDots =(string, limit)=> {
    if ( String(string).length <= limit) {
        return string;
    } else {
        return `${String(string).slice(0,limit)}...`
    }
}